import { inject, Injectable } from '@angular/core';
import { RestClientWrapper } from '../../market/rest-client-factory';
import { BybitHistoryProvider } from './exchange/bybit-provider';
import { BinanceUsdmHistoryProvider } from './exchange/binance-provider';
import { OkxHistoryProvider } from './exchange/okx-provider';
import { map } from 'rxjs';
import { DealsRequestParams } from './model';
import { InstrumentStorageService } from '../instrument-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TradeHistoryService {

  private instrumentStorage = inject(InstrumentStorageService)

  private createRestProvider(rest: RestClientWrapper) {
    if (rest.isBybit) {
      return new BybitHistoryProvider(rest.bybit)
    }
    if (rest.isBinanceUsdm) {
      return new BinanceUsdmHistoryProvider(rest.binanceUsdm)
    }
    if (rest.isOkx) {
      return new OkxHistoryProvider(rest.okx, this.instrumentStorage)
    }
    throw new Error('RestClient type error')
  }

  /**
   * Запрашивает позиции
   */
  requestPositions(rest: RestClientWrapper) {
    return this.createRestProvider(rest).requestPositions()
  }

  /**
   * Запрашивает сделки, возвращает их в обратном хронологическом порядке
   */
  /*requestDeals(rest: RestClientWrapper, params?: DealsRequestParams) {
    return this.createRestProvider(rest).requestDeals(params ?? {}).pipe(
      map(data => {
        if (data.deals.length) {
          const deal1 = data.deals[0]
          const deal2 = data.deals[data.deals.length - 1]
          if (deal1.timestamp < deal2.timestamp) {
            data.deals.reverse()
            data.fundings?.reverse()
          }
        }
        return data
      })
    )
  }*/

  /**
   * Запрашивает заявки, возвращает их в обратном хронологическом порядке
   */
  requestOrders(rest: RestClientWrapper, params?: DealsRequestParams) {
    return this.createRestProvider(rest).requestOrders(params ?? {}).pipe(
      map(orders => {
        if (orders.length) {
          const order1 = orders[0]
          const order2 = orders[orders.length - 1]
          if (order1.updateTimestamp < order2.updateTimestamp) {
            orders.reverse()
          }
        }
        return orders
      })
    )
  }

  /**
   * Запрашивает активные заявки
   */
  requestActiveOrders(rest: RestClientWrapper) {
    return this.createRestProvider(rest).requestActiveOrders()
  }

}
